import Select from './Select'
import { observer } from 'mobx-react-lite'

const PaxInput = observer(props => <Select {...props} style={{ ...props.style, width: '100%', paddingLeft: '44px' }} />)

export default PaxInput
